<template>
  <input
    ref="dataset-input"
    v-model="internalValue"
    @blur="formatNumericValue()"
  />
</template>

<script>
  export default {
    name: 'DatasetInput',
    emits: ['update:modelValue', 'validate'],
    props: {
      modelValue: {
        type: [String, Number],
        required: false,
        default: '0',
      },
    },
    computed: {
      internalValue: {
        get() {
          return this.modelValue.toString();
        },
        set(newValue) {
          const parsedValue = this.parseNumericValue(newValue);

          if (parsedValue === null) {
            this.$emit('update:modelValue', newValue.toString());
            return;
          }

          this.$emit('update:modelValue', parsedValue.toString());
        },
      },
    },
    mounted() {
      this.formatNumericValue();
    },
    methods: {
      formatNumericValue() {
        // Get the currency symbol from the input value
        let startingSymbols = '';
        const inputValue = this.internalValue;

        if (inputValue.charAt(0) === '-' && inputValue.charAt(1) === '$') {
          startingSymbols = '-$';
        } else if (
          inputValue.charAt(0) === '$' &&
          inputValue.charAt(1) === '-'
        ) {
          startingSymbols = '$-';
        } else if (inputValue.charAt(0) === '$') {
          startingSymbols = '$';
        } else if (inputValue.charAt(0) === '-') {
          startingSymbols = '-';
        }

        const cleanedValue = inputValue.replace(/[^.\d]/g, '');

        // Split the value into its integer and decimal parts
        const [integerPart, decimalPart] = cleanedValue.split('.');

        // Limit the decimal part to a maximum of 10 digits
        const truncatedDecimalPart = decimalPart
          ? decimalPart.slice(0, 10)
          : '';

        // Format the numeric value using Intl.NumberFormat
        const formattedNumber = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 10, // Always show up to 10 decimal places
        }).format(`${integerPart}.${truncatedDecimalPart}`);

        const newValue = `${startingSymbols}${formattedNumber}`;

        this.internalValue = newValue;
        this.$refs['dataset-input'].value = newValue;

        this.$emit('validate');
      },
      parseNumericValue(value) {
        const stringValue = value.toString();
        // Use a regular expression to clean the input of all letters and special characters except for the currency symbol, commas, and periods
        const cleanedValue = stringValue.replace(/[^-$,.\d]/g, '');

        // Remave all periods after the appearance of the first period
        const firstPeriodIndex = cleanedValue.indexOf('.');
        const cleanedValueWithoutExtraPeriods =
          firstPeriodIndex === -1
            ? cleanedValue
            : cleanedValue.substring(0, firstPeriodIndex + 1) +
              cleanedValue.substring(firstPeriodIndex + 1).replace(/\./g, '');

        return cleanedValueWithoutExtraPeriods;
      },
    },
  };
</script>
